export default __webpack_public_path__ + "static/media/DinersClub.20ffe61a.svg";